export const translations = {
  en: {
    nav: {
      capabilities: "What I Build",
      process: "How I Work",
      contact: "Contact",
    },
    hero: {
      label: "FREELANCE SOFTWARE DEVELOPER",
      title: "Build\nIntegrate\nAutomate",
      subtitle: "MuleSoft integrations, custom application development, and AI-powered automation — built to spec, delivered clean, and designed to last.",
      cta: "Get in touch",
      status1: "// AVAILABLE_FOR_PROJECTS",
      status2: "// REMOTE_FIRST",
      active_agents: "ACTIVE_PROJECTS",
      running: "RUNNING",
      workflow: "WORKFLOW_01",
      uptime: "98.4% UPTIME"
    },
    capabilities: {
      label: "What I Build",
      title: "Three areas.",
      subtitle: "Full-stack. End-to-end.",
      cards: [
        {
          id: '[01]',
          title: 'MuleSoft Integration',
          description: 'API design, system integration, and managed data flows on the MuleSoft Anypoint Platform. Enterprise-grade connectivity between applications, ERPs, CRMs, databases, and third-party services.',
          techStack: ['MuleSoft', 'Anypoint Platform', 'REST / SOAP']
        },
        {
          id: '[02]',
          title: 'Web & Mobile Development',
          description: 'Custom web and mobile applications designed around your requirements. Client-facing portals, internal tools, or full product builds — clean, maintainable code that integrates with your existing stack.',
          techStack: ['React', 'TypeScript', 'React Native']
        },
        {
          id: '[03]',
          title: 'Agentic & AI Solutions',
          description: 'Automated workflows, AI voice agents, and agentic systems that replace manual processes. Built with n8n, custom Python, and Retell AI — connected to the systems that run your business.',
          techStack: ['Python', 'n8n', 'Retell AI']
        }
      ],
      core_arch: "Tech Stack"
    },
    process: {
      label: "HOW I WORK",
      title: "From brief to delivery.",
      subtitle: "No unnecessary complexity.",
      steps: [
        {
          number: '01',
          title: 'Discovery',
          description: "We define the problem before touching a keyboard. What needs to be built, what it connects to, what success looks like. No assumptions, no scope creep.",
        },
        {
          number: '02',
          title: 'Design & Build',
          description: 'Architecture first, then execution. I design clean systems and write code that is structured, documented, and built to be maintained — by you or anyone else down the line.',
        },
        {
          number: '03',
          title: 'Delivery & Handoff',
          description: 'Full deployment, complete documentation, and a smooth handoff. You receive a system you own, understand, and can build on — ready to run from day one.',
        }
      ]
    },
    audit: {
      label: "AVAILABLE FOR PROJECTS",
      title: "Let's work together.",
      description: "MuleSoft integration, custom application, or AI-powered automation — get in touch and we'll define scope, timeline, and approach together. No commitment required.",
      cta: "Get in touch",
      response: "Response time: < 24 hours"
    },
    form: {
      name: "Name",
      brand: "Company / Project",
      email: "Email",
      submit: "Send",
      success: "Perfect — I'll be in touch within 24 hours."
    },
    footer: {
      role: "Software Engineer · MuleSoft Developer · AI Solutions",
      vat: "VAT: 18287251005",
      channels: "Communication Channels",
      connect: "Connect",
      status: "SYSTEM STATUS: ONLINE",
      rights: "© 2025 GIANCARLO GUACCI. ALL RIGHTS RESERVED.",
      encrypted: "ENCRYPTED CONNECTION"
    }
  },
  it: {
    nav: {
      capabilities: "Cosa costruisco",
      process: "Come lavoro",
      contact: "Contatti",
    },
    hero: {
      label: "SVILUPPATORE SOFTWARE FREELANCE",
      title: "Sviluppo Integrazione\nAutomazione",
      subtitle: "Integrazioni MuleSoft, sviluppo di applicazioni custom e automazioni AI — costruiti secondo le tue specifiche, consegnati con cura, progettati per durare.",
      cta: "Contattami",
      status1: "// DISPONIBILE_PER_PROGETTI",
      status2: "// REMOTE_FIRST",
      active_agents: "PROGETTI_ATTIVI",
      running: "IN_ESECUZIONE",
      workflow: "FLUSSO_01",
      uptime: "98.4% UPTIME"
    },
    capabilities: {
      label: "Cosa costruisco",
      title: "Tre aree.",
      subtitle: "Full-stack. Dall'inizio alla fine.",
      cards: [
        {
          id: '[01]',
          title: 'Integrazione MuleSoft',
          description: "Design API, integrazione di sistemi e flussi dati gestiti sulla piattaforma MuleSoft Anypoint. Connettività enterprise tra applicazioni, ERP, CRM, database e servizi di terze parti.",
          techStack: ['MuleSoft', 'Anypoint Platform', 'REST / SOAP']
        },
        {
          id: '[02]',
          title: 'Sviluppo Web & Mobile',
          description: 'Applicazioni web e mobile custom progettate sulle tue esigenze. Portali cliente, strumenti interni o prodotti completi — codice pulito, manutenibile e integrato con il tuo stack esistente.',
          techStack: ['React', 'TypeScript', 'React Native']
        },
        {
          id: '[03]',
          title: 'Soluzioni Agentiche & AI',
          description: 'Workflow automatizzati, voice agent AI e sistemi agentici che sostituiscono i processi manuali. Costruiti con n8n, Python custom e Retell AI — collegati ai sistemi che fanno girare la tua azienda.',
          techStack: ['Python', 'n8n', 'Retell AI']
        }
      ],
      core_arch: "Tech Stack"
    },
    process: {
      label: "COME LAVORO",
      title: "Dal brief alla consegna.",
      subtitle: "Senza complessità superflua.",
      steps: [
        {
          number: '01',
          title: 'Discovery',
          description: 'Definiamo il problema prima di scrivere una sola riga di codice. Cosa va costruito, a cosa si collega, come appare il successo. Nessuna assunzione, nessuna scope creep.',
        },
        {
          number: '02',
          title: 'Design & Build',
          description: "Prima l'architettura, poi l'esecuzione. Progetto sistemi puliti e scrivo codice strutturato, documentato e pensato per essere manutenuto — da te o da chiunque venga dopo.",
        },
        {
          number: '03',
          title: 'Consegna & Handoff',
          description: 'Deploy completo, documentazione dettagliata e un passaggio di consegne fluido. Ricevi un sistema che possiedi, capisci e su cui puoi costruire — operativo dal primo giorno.',
        }
      ]
    },
    audit: {
      label: "DISPONIBILE PER PROGETTI",
      title: "Lavoriamo insieme.",
      description: "Integrazione MuleSoft, applicazione custom o automazione AI — scrivimi e definiamo insieme scope, tempi e approccio. Nessun impegno richiesto.",
      cta: "Contattami",
      response: "Tempo di risposta: < 24 ore"
    },
    form: {
      name: "Nome",
      brand: "Azienda / Progetto",
      email: "Email",
      submit: "Invia",
      success: "Perfetto — ti rispondo entro 24 ore."
    },
    footer: {
      role: "Software Engineer · MuleSoft Developer · AI Solutions",
      vat: "P.IVA: 18287251005",
      channels: "Canali di Comunicazione",
      connect: "Connettiti",
      status: "STATO SISTEMA: ONLINE",
      rights: "© 2025 GIANCARLO GUACCI. TUTTI I DIRITTI RISERVATI.",
      encrypted: "CONNESSIONE CRITTOGRAFATA"
    }
  }
};